/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: af7a36564eab
 */

import * as z from "zod";
import {
  AssetDeliveryType,
  AssetDeliveryType$zodSchema,
} from "./assetdeliverytype.js";
import {
  ManagedDeliveryType,
  ManagedDeliveryType$zodSchema,
} from "./manageddeliverytype.js";

/**
 * Delivery types accepted by upload and rename operations.
 */
export type UploadDeliveryType = ManagedDeliveryType | AssetDeliveryType;

export const UploadDeliveryType$zodSchema: z.ZodType<UploadDeliveryType> = z
  .union([
    ManagedDeliveryType$zodSchema,
    AssetDeliveryType$zodSchema,
  ]).describe("Delivery types accepted by upload and rename operations.");
